import { IUserSettingsAccepted } from '../../../actions/userObject/settings/requestFetchUserSettings'
import { IUserObjectStore } from '../index'

export default function(
  state: IUserObjectStore,
  action: IUserSettingsAccepted,
): IUserObjectStore {
  return {
    ...state,
    settingsRequest: {
      ...state.settingsRequest,
      acceptedCount: ++state.settingsRequest.acceptedCount,
      isLoading: false,
    },
    userObject: {
      ...state.userObject,
      settings: {
        ...state.userObject.settings,
        ...action.settings,
      },
    },
  }
}
